import { useState, useEffect, useRef } from "react";

export default function SearchBar({ onSearch, search }) {
  const [value, setValue] = useState("");
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;
  const mountedRef = useRef(false);
  const externalResetRef = useRef(false);

  // Clear text when search is externally reset (e.g., stat card click)
  useEffect(() => {
    if (search === null) {
      externalResetRef.current = true;
      setValue("");
    }
  }, [search]);

  // Debounce search — only fires when user actually types
  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
      return;
    }
    if (externalResetRef.current) {
      externalResetRef.current = false;
      return;
    }
    const timer = setTimeout(() => {
      onSearchRef.current(value.trim() || null);
    }, 300);
    return () => clearTimeout(timer);
  }, [value]);

  const handleClear = () => {
    setValue("");
  };

  return (
    <div className="flex gap-2">
      <input
        type="text"
        placeholder="Search JO#, name, account…"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="border rounded px-3 py-1.5 text-sm w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      {value && (
        <button
          type="button"
          onClick={handleClear}
          className="text-sm text-gray-500 hover:text-gray-800"
        >
          Clear
        </button>
      )}
    </div>
  );
}
